import router from '@/router'
import Vue from 'vue'
export const formatDate = (date) => {
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  return y + m + d;
}

// 深拷贝
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

// export function handelCopyText (text) {
//   console.log(text)
//   // 使用 navigator.clipboard 写入到剪贴板
//   window.navigator.clipboard.writeText(text).then(() => {
//     // 复制成功提示
//     this.$message.success("复制成功！");
//   }).catch(() => {
//     // 复制失败提示
//     this.$message.error("复制失败，请稍后重试");
//   });
// }
export function formatNumber(value) {
  // 只允许数字和小数点
  value = value.replace(/[^\d.]/g, '');

  // 如果首位是小数点，自动补0
  if (value.startsWith('.')) {
    value = '0' + value;
  }

  // 限制最多两位小数
  if (value.includes('.')) {
    const parts = value.split('.');
    parts[1] = parts[1].slice(0, 2); // 保留最多两位小数
    value = parts.join('.');
  }

  // 限制输入范围在 0.00 到 10.00 之间
  if (parseFloat(value) < 0) {
    value = '0.00';
  }
  if (parseFloat(value) > 9) {
    value = '9.00';
  }
  return value
}

export const goExportCenter = async () => {
  await Vue.prototype.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
    showCancelButton: true,
    confirmButtonText: '前往导出列表',
    cancelButtonText: '取消',
    callback: action => {
      if(action === 'confirm'){
        router.push({ path: "/pc/exportCenter/index" });
      }
    }
  });

}

function formatDate2(date) {
  const padZero = (n) => (n < 10 ? '0' + n : n)

  const year = date.getFullYear()
  const month = padZero(date.getMonth() + 1)
  const day = padZero(date.getDate())

  const hours = padZero(date.getHours())
  const minutes = padZero(date.getMinutes())
  const seconds = padZero(date.getSeconds())

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
//最近7天
export function lastSevenDays(n) {
  const now = new Date()

  // 设置结束时间为当天的 23:59:59
  const endDate = new Date(now)
  endDate.setHours(23, 59, 59, 999)

  // 设置开始时间为7天前的 00:00:00
  const startDate = new Date(endDate)
  startDate.setDate(endDate.getDate() - (n-1)) // 包含今天共几天
  startDate.setHours(0, 0, 0, 0)

  // this.searchForm.useTime = [
  //   formatDate2(startDate),
  //   formatDate2(endDate)
  // ]
  // this.searchForm.useTimeStart = formatDate2(startDate)
  // this.searchForm.useTimeEnd = formatDate2(endDate)
  return {
    start:formatDate2(startDate),
    end:formatDate2(endDate),
  }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js